import axios from "axios";
import { initVisibilityToggles } from "./visibility-toggle.js";

var init = function () {
  let $grid = document.getElementById("zoteroPublicationsGrid");
  const retrieveErrorHTML = "<p>Unable to retrieve publications.</p>";
  axios
    .get("/about/getZoteroPublications/")
    .then(function (response) {
      const zoteroPublications = response?.data?.html;
      document.getElementById("zoteroPublicationsLoader").remove();
      if (zoteroPublications) {
        $grid.innerHTML = zoteroPublications;
        initVisibilityToggles();
      } else {
        $grid.innerHTML = retrieveErrorHTML;
      }
    })
    .catch(() => {
      document.getElementById("zoteroPublicationsLoader").remove();
      $grid.innerHTML = retrieveErrorHTML;
    });
};

window.addEventListener("load", init, false);
